export default {
	"classify.ProductRequestError": "Product request error",
	"classify.RequestError": "Request error",
	"classify.MarketingMarketplaceListPage": "Marketing Marketplace list page",
	"classify.MarketingMarketplace": "Marketing Marketplace",
	"classify.all": "all",
	"classify.CommodityAcquisition": "Commodity Acquisition...",
	"classify.MarketingMarketplaceListingPageProductClick": "Marketing Marketplace listing page_Product click",
	"classify.AListOfStoreItems": "A list of store items"
}